import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'

import { API__USER } from '../../api'

import { USER__SET_DETAILS } from '../../store/actions'

import Loader from '../../common/components/Loader/Loader'

import CardsList from './components/CardsList/CardsList'
import Card from './components/Card/Card'
import ChangeInfoForm from './components/ChangeInfoForm/ChangeInfoForm'
import ChangePasswordForm from './components/ChangePasswordForm/ChangePasswordForm'
import SetPasswordForm from './components/SetPasswordForm/SetPasswordForm'
import NewsSubscription from './components/NewsSubscription/NewsSubscription'
import AccountDelete from './components/AccountDelete/AccountDelete'
import Integration from './components/Integration/Integration'

import './AccountSettings.scss'

class AccountSettings extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isReady: false,
            userDetails: null,
        }
        this.baseState = this.state
    }

    async componentDidMount() {
        const { user } = this.props
        const userDetails = await API__USER.GET_DETAILS(user.id)

        this.setState({
            isReady: true,
            userDetails,
        })
    }

    refreshUserData = async updatedUser => {
        const { REDUX__SET_USER_DETAILS, user } = this.props
        let newUserDetails
        if (updatedUser) {
            REDUX__SET_USER_DETAILS(updatedUser)
            newUserDetails = updatedUser
        } else {
            const userDetails = await API__USER.GET_DETAILS(user.id)

            REDUX__SET_USER_DETAILS(userDetails)
            newUserDetails = userDetails
        }
        this.setState({
            userDetails: newUserDetails,
        })
    }

    render() {
        const { t } = this.props
        const { isReady, userDetails } = this.state

        const getAvatarText = () => {
            if (userDetails.firstName && userDetails.firstName.length) {
                return (
                    <>
                        {userDetails.firstName.charAt(0)}
                        {userDetails.lastName && userDetails.lastName.length ? userDetails.lastName.charAt(0) : null}
                    </>
                )
            }
            return userDetails.login.charAt(0)
        }

        return (
            <div className="page page--account_settings" data-structure="1">
                <Helmet>
                    <title>{t('Account settings')} | Interacty</title>
                </Helmet>
                {isReady ? (
                    <section>
                        <div className="container">
                            <div className="page-bar">
                                <div className="title">
                                    <h1>{t('Account settings')}</h1>
                                </div>
                            </div>

                            <CardsList>
                                <Card title={t('Manage your profile')}>
                                    <div className="user-avatar">{getAvatarText()}</div>
                                    <ChangeInfoForm
                                        userDetails={userDetails}
                                        onSuccess={updatedUser => this.refreshUserData(updatedUser)}
                                    />
                                </Card>
                                {userDetails.isHasPassword ? (
                                    <Card title={t('Update your password')}>
                                        <ChangePasswordForm
                                            userDetails={userDetails}
                                            onSuccess={() => this.refreshUserData(null)}
                                        />
                                    </Card>
                                ) : (
                                    <Card title={t('Set your password')}>
                                        <SetPasswordForm
                                            userDetails={userDetails}
                                            onSuccess={() => this.refreshUserData(null)}
                                        />
                                    </Card>
                                )}
                                <Card title={t('Manage your email subscription')}>
                                    <NewsSubscription
                                        userDetails={userDetails}
                                        onSuccess={updatedUser => this.refreshUserData(updatedUser)}
                                    />
                                </Card>
                                <Card title={t('Integration')}>
                                    <Integration userDetails={userDetails} />
                                </Card>
                                <Card title={t('Delete your account')}>
                                    <AccountDelete userDetails={userDetails} />
                                </Card>
                            </CardsList>
                        </div>
                    </section>
                ) : (
                    <Loader />
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    user: state.user,
})

const mapDispatchToProps = dispatch => ({
    REDUX__SET_USER_DETAILS: obj => dispatch(USER__SET_DETAILS(obj)),
})

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation('translations'))(AccountSettings)
